import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { configuracionEvento } from "../../../data-store/actions/events-actions";

import TitleResultReport from "./TitleResultReport";
import TitleResultReportDefault from "./TitleResultReportDefault";

import AtleteDetailsModal from "../Modals/atleteDetailsModal";
import AtleteDetailsContainer from "../reports/atleteDetail/AtleteDetailContainer";

import { ControlesAtleta } from "./reportsLogic";
import { DescargarCertificadoReg } from "./atleteDetail/certificadoLogic";

import FormDialog from "../Modals/FormDialog";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import SimpleDialogDemo from "../../Landing/LayoutContainers/SimpleDialog";
import DNFAndDQView from "./DNFAndDQView";
import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  compactCell: {
    padding: "0px 10px",
    margin: "0px",
    lineHeight: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  compactCellSticky: {
    padding: "0px 10px",
    margin: "0px",
    lineHeight: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    position: "sticky",
    left: 0,
    backgroundColor: "#ffffff",
    borderRight: "2px solid red",
    zIndex: 1000,
  }

});

const setStatus = (resultadoFunc, eventConfigurationFunc) => {
  resultadoFunc.text = "";
  resultadoFunc.button = "";
  if (resultadoFunc.nombre.indexOf("*") > 0) {
    resultadoFunc.pG = 0;
    resultadoFunc.pR = 0;
    resultadoFunc.pCat = 0;
    resultadoFunc.dnfPlus = true;
  }
  if (resultadoFunc.borrado) {
    resultadoFunc.dq = true;
  }
  if (!resultadoFunc.borrado && resultadoFunc.pG === 0) {
    resultadoFunc.dnf = true;
  }
  if (!resultadoFunc.registroSalida && !resultadoFunc.parciales && resultadoFunc.pG === 0) {
    resultadoFunc.dns = true;
  }
  if (resultadoFunc.dnfPlus && !resultadoFunc.dns) {
    resultadoFunc.text = "El atleta no finalizó el evento en el tiempo previsto para la distancia";
    resultadoFunc.button = "DNF";
  } else if (resultadoFunc.dnf && !resultadoFunc.dns) {
    resultadoFunc.text = "El atleta no finalizó el evento";
    resultadoFunc.button = "DNF";
  } else if (resultadoFunc.dq) {
    resultadoFunc.text = "El atleta fue descalificado por los jueces del evento";
    resultadoFunc.button = "DQ";
  } else if (resultadoFunc.dns && !resultadoFunc.dq) {
    resultadoFunc.text = "El atleta no inició el evento";
    resultadoFunc.button = "DNS";
  }

  return resultadoFunc;
};

const RowResultReport = ({ data, controles, controlesArray, puntosControl }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const eventConfiguration = useSelector((state) => state.events.eventConfiguration);

  let element;
  const typeRow = data.typeRow;

  if (typeRow === 1) {
    element = (
      <TitleResultReport data={data} controles={controles} controlesArray={controlesArray} />
    );
  } else if (typeRow === 3) {
    element = (
      <TitleResultReportDefault data={data} controles={controles} controlesArray={controlesArray} />
    );
  } else {
    const resultado = setStatus({ ...data.result }, eventConfiguration);

    const controlesAtleta = ControlesAtleta(puntosControl, resultado, controlesArray);
    const controlesTD = controlesAtleta.map((control, index) => (
      <TableCell align="center" key={index} style={{ backgroundColor: (control.value === "N/R" ? "#4db6ac" : "") }} className={classes.compactCell}>{control.value}</TableCell>
    ));


    const posiciones = [];
    if (resultado.pG === 0) {
      posiciones.push(
        <TableCell align="center" colSpan={3} className={classes.compactCell}>
          <SimpleDialogDemo fullScreen={false} buttonText={resultado.button}>
            <DNFAndDQView text={resultado.text} />
          </SimpleDialogDemo>
        </TableCell>
      );
    } else {
      // En filas de subclasificación (resultado.pSub !== undefined) se
      // muestra la posición en esa subclasificación en el mismo lugar que
      // "Lugar Categoría" en vez de agregar una columna más — así la tabla
      // tiene siempre la misma cantidad de columnas en todas las secciones,
      // se mezclen o no filas normales y de subclasificación.
      const posicionCategoria = resultado.pSub !== undefined ? resultado.pSub : resultado.pCat;
      posiciones.push(<TableCell align="center" className={classes.compactCell}>{resultado.pG}</TableCell>);
      posiciones.push(<TableCell align="center" className={classes.compactCell}>{resultado.pR}</TableCell>);
      posiciones.push(<TableCell align="center" className={classes.compactCell}>{posicionCategoria}</TableCell>);
    }

    element = (
      <TableRow>
        <TableCell align="center" className={classes.compactCellSticky}>{resultado.num}</TableCell>
        {posiciones}
        <TableCell align="center" className={classes.compactCell} style={{ minWidth: "350px" }}>
          <FormDialog
            buttomLabel={resultado.nombre}
            ShowIcon={false}
            ButtonStyle={null}
            maxWidthProp={"lg"}
            style={{ minHeight: "80vh", maxHeight: "80vh" }}
            report={<AtleteDetailsContainer eventDetail={eventDetail} resultado={resultado} />}
          />
        </TableCell>
        <TableCell align="center" className={classes.compactCell}>{resultado.gen}</TableCell>
        <TableCell align="center" className={classes.compactCell}>{resultado.cat}</TableCell>
        <TableCell align="center" className={classes.compactCell}>{resultado.mod}</TableCell>
        {controlesTD}
        <TableCell align="center" className={classes.compactCell}>{resultado.toMS || resultado.to}</TableCell>
        <TableCell align="center" className={classes.compactCell}>{resultado.tcMS || resultado.tc}</TableCell>
      </TableRow>
    );
  }

  return element;
};

export default RowResultReport;
